import React from "react";
import ProfileAvatar from "./ProfileAvatar";
import CopyIdButton from "./CopyIdButton";

interface PageItemProps {
  picture?: string | null;
  name: string;
  description?: string;
  id?: string;
  idLabel?: string;
  avatarSize?: "xs" | "sm" | "md" | "lg";
  isDefault?: boolean;
}

const PageItem: React.FC<PageItemProps> = ({
  picture,
  name,
  description,
  id,
  idLabel = "page id",
  avatarSize = "xs",
  isDefault = false,
}) => {
  return (
    <div className="flex items-center gap-3">
      <ProfileAvatar picture={picture} name={name} size={avatarSize} showDefaultBadge={isDefault} />
      <div className="flex-1 min-w-0">
        <div
          className="text-base font-bold text-gray-900 truncate"
          style={{ fontSize: "16px", lineHeight: "24px" }}
        >
          {name}
        </div>
        {description && (
          <div
            className="text-sm text-gray-500 mt-0"
            style={{ fontSize: "14px", lineHeight: "20px" }}
          >
            {description}
          </div>
        )}
        {id && <CopyIdButton id={id} tooltipId={`copy-page-id-tooltip-${id}`} label={idLabel} />}
      </div>
    </div>
  );
};

export default PageItem;
